import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { LoadingProvider } from "./contexts/loading.ctx";
import LoadingComp from "./components/common/loader";
import DismissableToast from "./components/common/dismissableToast";
import { ConfigProvider, ThemeConfig } from "antd";
import { MenuProvider } from "./contexts/menu.ctx";
import { ConfirmProvider } from "./components/common/confirm";

const config: ThemeConfig = {
  token: {
    colorPrimary: "#ffbe18",
    // colorBorder: "#ffbe18",
    colorBgSpotlight: "#ffbe18",
    fontFamily: "Rosario sans-serif",
    fontSize: 16,

  },
 
};

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfirmProvider>
      <LoadingProvider>
        <MenuProvider>
          <BrowserRouter>
            <ConfigProvider theme={config}>
              <DismissableToast />
              <LoadingComp />
              <App />
            </ConfigProvider>
          </BrowserRouter>
        </MenuProvider>
      </LoadingProvider>
      </ConfirmProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
